@if(!isLoadingPage()){
    <app-nav-bar></app-nav-bar>
    <div class="body-section">
        <app-side-bar></app-side-bar>
        <router-outlet></router-outlet>
    </div>
}@else{
    <router-outlet></router-outlet>
}